/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Collection {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import * as Modules from "./collections"

const Collection = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  collection, //example prop
}) => {
  const moduleName =
    collection.handle[0].toUpperCase() +
    collection.handle.slice(1).toLowerCase()

  if (typeof Modules[moduleName] === "undefined") {
    return null
  }
  const Module = Modules[moduleName]

  return (
    <Section {...{ suptitle, title, subtitle, button, buttonPosition }}>
      <Module />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on CollectionModule {
 *   ...CollectionModuleFragment
 * }
 *
 * This is also what you will get in the props of your Collection
 * resolver component.
 */
export const query = graphql`
  fragment CollectionModuleFragment on CollectionModule {
    collection {
      handle
    }
  }
`

export { Collection }
